export var familyMemDetailsMapper = function (data) {
    if (data && data.length > 0) {
        return data.map(function (item) {
            return {
                headAcCode: item.headaccode,
                headAcName: item.headacname,
                memberAcCode: item.memberaccode,
                memberName: item.membername,
                relation: item.relation,
                mobileNo: item.mobileNo,
                otpOnMobile: item.otponmobile,
                otpOnEmail: item.otponemail,
                email: item.email,
                btnText: item.btntext,
                status: item.status,
                loa: item.loa,
                remove: item.remove,
            };
        });
    }
    return {};
};
export var familyTaggingSearchMapper = function (searchData) {
    var resultArray = [];
    if (searchData.length > 0) {
        resultArray = searchData.map(function (record) {
            var resultObj = {
                clientName: record.clientName,
                userName: record.userName,
                accountCode: record.accountCode,
                udnNo: record.udnno,
                email: record.email,
                leadId: record.leadid,
                mobileNo: record.mobileNo,
                pan: record.pan,
                priority: record.priority,
                msgFlag: record.msgFlag,
                accessMsg: record.accessMsg,
            };
            return resultObj;
        });
    }
    return resultArray;
};
